/**
 * Ask again (remind_ask, migration 1059; PRD-tasks-asks-and-my-work FR-7).
 *
 * The person who asked (or a workspace admin) reminds the people a task or a
 * request still waits on. The server sends at most one reminder a day per ask
 * per person. The reminder is a notice of class ask, so it reaches them as their
 * switches say (phone, email, Slack); the ask itself is already on their Home.
 */
import { getTypedSupabaseClient } from './typedSupabaseClient';

export type RemindSubject = 'task' | 'assignment';

type Rpc = (fn: string, args?: Record<string, unknown>) => PromiseLike<{ data: unknown; error: { message: string } | null }>;

export async function remindAsk(
  type: RemindSubject,
  id: string,
): Promise<{ ok: true; reminded: number } | { ok: false; error: string }> {
  const client = getTypedSupabaseClient() as unknown as { rpc: Rpc };
  const { data, error } = await client.rpc('remind_ask', { p_subject_type: type, p_subject_id: id });
  if (error) return { ok: false, error: error.message };
  const reminded = (data as { reminded?: unknown } | null)?.reminded;
  return { ok: true, reminded: typeof reminded === 'number' ? reminded : 0 };
}
